// Libraries
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Admin } from '../models/Admin';
// Services
import { SessionService } from '../services/SessionService';
import { AdminService } from '../services/AdminService';
import { devEnv, testEnv, procEnv, stagingEnv, localEnv, demoEnv, bisHanoiEnv, bisHanoiDevEnv, bisHanoiStagingEnv, ishcmcEnv, aavnIshcmcEnv, primaryIshcmcEnv, secondaryIshcmcEnv, isspEnv, demoHelenEnv } from '../../../config/config'

@Component({
    selector: 'admin-logout',
    template:   '',
    styles:     []
})

export class LogoutComponent {
    protected errorMessage: string;
    protected adminData: Admin;
    protected hostName: string;
    // For logout navigate

    constructor(
        protected router: Router,
        protected sessionService: SessionService,
        protected adminService: AdminService
        
    ) {}

    ngOnInit() {
        // Delete session from system
        
		this.hostName = window.location.hostname;
        this.deleteSession();
        this.adminData = this.adminService.getAdminSessionData();
    }

    /**
     * Delete user session data.
     */
    deleteSession() {
        this.sessionService.deleteAdminSession()
            .subscribe(
                complete => {
                    // Clear user session
                    this.adminService.clearAdminSessionData();
                    // Fire user session data changed event
                    this.adminService.adminDataChanged(null);
                    // Redirect to desired URL
                    if(Object.values(devEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${devEnv.services}`;
                    }
                    else if(Object.values(demoEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${demoEnv.services}`;
                    }
                    else if (Object.values(bisHanoiEnv).indexOf(this.hostName) !== -1) {
                        return window.location.href = `http://${bisHanoiEnv.services}`;
                    }
                    else if (Object.values(bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
                        return window.location.href = `http://${bisHanoiDevEnv.services}`;
                    }
                    else if(Object.values(bisHanoiStagingEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${bisHanoiStagingEnv.services}`;
                    }
                    else if(Object.values(ishcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${ishcmcEnv.services}`;
                    }
                    else if(Object.values(aavnIshcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${aavnIshcmcEnv.services}`;
                    }
                    else if(Object.values(primaryIshcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${primaryIshcmcEnv.services}`;
                    }
                    else if(Object.values(secondaryIshcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${secondaryIshcmcEnv.services}`;
                    }
                    else if(Object.values(isspEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${isspEnv.services}`;
                    }
                    else if(Object.values(demoHelenEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${demoHelenEnv.services}`;
                    }
                    else if(Object.values(testEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${testEnv.services}`;
                    }
                    else if(Object.values(stagingEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${stagingEnv.services}`;
                    }
                    else if(Object.values(procEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${procEnv.services}`;
                    }
                    else{
                        return window.location.href = `http://${localEnv.services}`;
                    }
                },
                error    => this.errorMessage = <any> error
            );
    }

    // Redirect to desired url
    private redirect(redirectUrl: string) {
        this.router.navigate([redirectUrl]); 
    }
}



// WEBPACK FOOTER //
// ./src/common/modules/admin/logout/LogoutComponent.ts